import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Utils } from '../../common/utils';
import { MapBaseComponent } from '../../common/map-base/map-base.component';
import { ContextService } from '../../services/context.service';
import { IEvent } from '../../services/match.service';
import { StatsService } from '../../services/stats.service';
import { ISelectedPlayer } from '../players-list/players-list.component';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy {
  _events: IEvent[] = [];
  _teams: any = {};
  @Input() get teams(): any { return this._teams; }
           set teams(teams: any) {
             this._teams = teams;
             this.indexTeams();
           }
  @Input() get events(): IEvent[] { return this._events; }
           set events(events: IEvent[]) {
              this._events = events;
           }
  @Input() stats: any[] = [];

  @ViewChild('map', { static: false }) mapElem: any;

  map: any;
  mapMode = 'zone';

  zonesLayer: any;
  zoneMarkersLayer: any;

  teamsIndex = {};
  playersIndex = {};
  playersSelected: ISelectedPlayer[] = [null, null];
  zoneStats: any;

  popupStats = {};

  comparative = '';

  utils = Utils;

  live = false;
  showLegend = false;
  private contextSubscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private context: ContextService
  ) {
    this.comparative = this.translateService.instant('Comparative');
  }

  ngOnInit() {
    // Listen for changes on context
    this.contextSubscription = this.context.contextChanged$.subscribe((context) => {
      this.live = context.live;
      if (this.live) {
        this.mapMode = 'raw';
      }
    });
    this.live = this.context.isLive();
  }

  ngOnDestroy() {
    if (this.contextSubscription) { this.contextSubscription.unsubscribe(); }
  }

  private indexTeams() {
    this.teamsIndex = {};
    this.playersIndex = {};
    if (!this.teams) {
      return;
    }
    if (this.teams.home) {
      this.teamsIndex[this.teams.home.id] = {
        code: this.teams.home.code,
        name: this.teams.home.name,
      };
      this.playersIndex = this.teams.home.players.reduce((acum, elem) => {
        acum[elem.id] = elem;
        return acum;
      }, {});
    }
    if (this.teams.visitor) {
      this.teamsIndex[this.teams.visitor.id] = {
        code: this.teams.visitor.code,
        name: this.teams.visitor.name,
      };
      this.playersIndex = this.teams.visitor.players.reduce((acum, elem) => {
        acum[elem.id] = elem;
        return acum;
      }, this.playersIndex);
    }
  }

  onQuarterChange(event) {
    this.context.setQuarter(event);
  }

  onMapModeChange(event) {
    if (this.mapMode !== event) {
      this.mapMode = event;
      this.clearPlayerSelected();
    }
  }

  onPlayerSelected(event, team) {
    this.playersSelected[team] = event;
    // HACK to force detecting changes
    this.playersSelected = [...this.playersSelected];
  }

  clearPlayerSelected() {
    this.playersSelected = [null, null];
  }

  checkPlayerSelected() {
    return this.playersSelected[0] !== null || this.playersSelected[1] !== null;
  }

  getNameCurrentPlaterSelected() {
    if (this.playersSelected[0] !== null && this.playersSelected[1] !== null) {
      return this.comparative;
    } else if (this.playersSelected[0] !== null || this.playersSelected[1] !== null) {
      return this.playersSelected[0] !== null
        ? this.playersSelected[0].name
        : this.playersSelected[1].name;
    }
    return '';
  }

  hasStarted() {
    const date = Date.parse(this.teams && this.teams.date);
    return (date && (Date.now() > date));
  }
}
